import { Dispatch } from "redux";
import request from "../../util/request";
import actions from "../../util/actions";
import errorHandler from "../../util/error-handler";

export const getKittyLinkedContributions = (_id: string, search: string, page: number, per_page: number) => {
  return (dispatch: Dispatch): void => {
    dispatch({
      type: actions.KITTY_LINKED_CONTRIBUTIONS_HTTP_LOADING
    });

    request({
      method: "get",
      pathname: "getKittyLinkedContributions",
      params: { _id, search, page, per_page }
    })
      .then((response) => {
        dispatch({
          type: actions.KITTY_LINKED_CONTRIBUTIONS_HTTP_COMPLETE,
          payload: {
            response: response
          }
        });

        dispatch({
          type: actions.SET_KITTY_LINKED_CONTRIBUTIONS_DETAILS,
          payload: {
            ...response.data.content
          }
        });
      })
      .catch((error) => {
        errorHandler(actions.KITTY_LINKED_CONTRIBUTIONS_HTTP_ERROR, error, dispatch);
      });
  };
};
